import GoalsSerializer from './base';

export default class Subject extends GoalsSerializer {}
